import addToCartService from '../services/rbata.addToCartService';
import loadProduct from './rbata.load-product';
import imagePanel from './rbata.imagepanel';
import trackingPdp from '../tracking/rbata.pdp';
import Breakpoints from 'breakpoints-js/src/breakpoints';
import ctaBar from './rbata.cta-bar';
import personalizeService from '../services/rbata.personalizeService';
import personalizedProductService from '../services/rbata.personalizedProductService';
import notifyMeService from '../services/rbata.notifyMeService';
import logger from '../utils/rbata.logger';
import pdpSliderGallery from './rbata.pdpSliderGallery';
import employee from '../employee/rbata.employee';
import urlService from '../services/rbata.urlService';
import spinner from '../utils/rbata.spinner';
import relatedProducts from '../components/rbata.relatedproducts';
import completeTheLook from '../components/rbata.completeTheLook';
import mediaLazyLoad from '../utils/rbata.mediaLazyLoad';
import parallax from '../utils/rbata.parallax';
import scrollToTop from '../utils/rbata.scrollToTop';
import startCloudinaryResponsive from '../utils/rbata.cloudinary';
import productTileSlider from '../plp/rbata.tileSlider';

const detailPanel = {
    pdpMainSection:               '#page-main__pdp',
    $pdpMainSection:              $('#page-main__pdp'),
    sizeSelector:                 '#js-size-selector__wrapper',
    sizeInitialized:              false,
    giftCard:                     {isGiftcard: false, amount: 0, message: ''},
    colorVariantSliderSelector:   '#js-color-selector__slider',
    $colorVariantSliderContainer: undefined,
    colorVariantSlider:           null,
    searchString:                 null,
    accessedVariant:              null,
    heroClassName:                'pdp__wrapper--hero',
    productImageryModule:         null,
    customerServiceModal:         null,

    cacheSelectors() {
        this.detailsPanelArea             = $('#js-pdp__details-panel');
        this.giftCard.isGiftcard          = this.detailsPanelArea.data('gift-card');
        this.$colorVariantSliderContainer = $(this.colorVariantSliderSelector);
        this.searchString                 = new URLSearchParams(window.location.search)
        this.accessedVariant              = this.searchString.get('vc');
        this.productImageryModule         = $('#cms-productimagery-module__component');
        this.customerServiceModal         = $('#pdp__cs-modal');
    },

    updateURL(productCode) {
        detailPanel.searchString.delete('vc');
        const searchString          = detailPanel.searchString.toString();
        const cleanSearch           = searchString.replace('?', '');
        detailPanel.accessedVariant = productCode;
        history.replaceState('', '', `${window.location.pathname}?vc=${productCode}${searchString.length > 0 ? '&' : ''}${cleanSearch}`);
    },

    preselectFirstAvailableSize(wrapper, button) {
        const buttonSizeWrapper = detailPanel.$pdpMainSection.find(wrapper);

        buttonSizeWrapper.map((index, wrapper) => {
            const $wrapper         = $(wrapper)
            const firstAvailable   = $wrapper.find('button[data-out-of-stock=false]');
            const smallestNotifyMe = $wrapper.find('button[data-notify-me=true]');

            const current           = $wrapper.find(`button[data-product-code='${detailPanel.accessedVariant}']`);
            const currentOutOfStock = current.data('out-of-stock');

            if ($wrapper.length > 0) { //RBATA-2481
                if (current.length && !currentOutOfStock) { // for complete the look this will be false
                    // In case requested variant is in stock
                    $(current).click();
                } else {
                    if (firstAvailable.length > 0) {
                        // In case requested variant out of stock, then pick first available in stock
                        $(firstAvailable[0]).trigger('click');
                    } else if (smallestNotifyMe.length > 0) {
                        // In case there is no stock product, select first one with notify me
                        $(smallestNotifyMe[0]).trigger('click');
                    } else {
                        // In case no stock and no notify me active, just select first one
                        $($wrapper.find(button)[0]).trigger('click');
                    }
                }
            }
        });
    },

    colorVariantBindHandler() {
        this.$pdpMainSection.on('click', '.js-color-selector__color', (evt) => {
            if (evt.currentTarget.classList.contains('color-selector__color--active')) {
                return;
            }
            this.updateURL(evt.currentTarget.dataset.productCode);
            // be aware: order of objects can be crucial
            // (adjustAdd2CartButtons for example need 'add-cart__form' already added to DOM)
            // cacheSelectors() have to be called at the end
            loadProduct.refreshVariantStatus(evt.currentTarget.dataset.productCode, this.$pdpMainSection, [
                {
                    selector: '#js-pdp__hero-panel-container',
                    before:   null,
                    after:    () => {
                        if ($('#js-pdp__hero-panel').length) {
                            this.productImageryModule.addClass(this.heroClassName);
                        } else {
                            this.productImageryModule.removeClass(this.heroClassName);
                        }
                    }
                },
                {
                    selector: '#js-pdp__details-panel',
                    before:   () => {
                        ctaBar.unbindCtaObservable();
                        this.destroyColorVariantSlider();
                    },
                    after:    () => {
                        this.adjustSizeVariantState();
                        scrollToTop.onClickAction();
                        this.descriptionShortener();
                        this.buildColorVariantSlider();
                        this.adjustAdd2CartButtons();
                        this.cacheSelectors();
                        ctaBar.isCartIntersecting = true;
                        ctaBar.bindCtaObservable();
                    }
                },
                {
                    selector: '#js-pdp__image-panel',
                    before:   () => {
                        imagePanel.destroySlider();
                    },
                    after:    () => {
                        pdpSliderGallery.extractImageSources();
                        imagePanel.rebuildSlider();
                        pdpSliderGallery.cacheSelectors();
                    }
                },
                {
                    selector: '.pdp__additional-panel',
                    before:   null,
                    after:    () => {
                        this.calculateStickyType();
                    }
                },
                {
                    selector: '#js-complete-the-look__container',
                    before:   null,
                    after:    () => {
                        completeTheLook.init();
                        this.adjustPersonalizedPrice();
                        this.adjustCompleteTheLookButton();
                        mediaLazyLoad.refreshLazyLoad();
                        startCloudinaryResponsive();
                        productTileSlider.reInit();
                    }
                },
                {
                    selector: '#js-pdp__hero-detail',
                    before:   null,
                    after:    null
                }
            ]);
        });
    },
    sizeVariantBindHandler() {
        this.$pdpMainSection.on('click', '.js-size-selector__size', (evt) => {
            if (evt.currentTarget.classList.contains('size-selector__size--active')) {
                return;
            }
            this.updateURL(evt.currentTarget.dataset.productCode);
            // be aware: order of objects can be crucial
            // (adjustAdd2CartButtons for example need 'add-cart__form' already added to DOM)
            // cacheSelectors() have to be called at the end
            loadProduct.refreshVariantStatus(evt.currentTarget.dataset.productCode, this.$pdpMainSection, [
                {
                    selector: '#js-pdp__details-panel',
                    before:   () => {
                        ctaBar.unbindCtaObservable();
                        this.destroyColorVariantSlider();
                    },
                    after:    () => {
                        this.sizeInitialized = true;
                        this.adjustSizeVariantState();
                        this.adjustCompleteTheLookButton();
                        this.descriptionShortener();
                        this.buildColorVariantSlider();
                        this.adjustAdd2CartButtons();
                        this.cacheSelectors();
                        ctaBar.isCartIntersecting = true;
                        ctaBar.bindCtaObservable();
                        this.adjustPersonalizedPrice();
                    }
                },
                {
                    selector: '.pdp__additional-panel',
                    before:   null,
                    after:    () => {
                        this.calculateStickyType();
                    }
                }
            ]);
        });
    },
    chooseSizeBindHandler() {
        this.$pdpMainSection.on('click', '#js-pdp__choose-size', (evt) => {
            evt.preventDefault();
            this.clearErrorMessages();
            this.renderErrorMessages([evt.currentTarget.dataset.message]);
        });
    },
    adjustSizeVariantState() {
        // oneSize product. Status is already fixed. Personalized price is fetched on init
        if ($(this.sizeSelector).hasClass('size-selector__wrapper--onesize')) {
            this.$pdpMainSection
                .find(this.sizeSelector)
                .animate({opacity: 1}, 200);
            // show correct button
            this.sizeInitialized = true;
            this.adjustAdd2CartButtons();
            return;
        }
        if (this.sizeInitialized) {
            this.$pdpMainSection
                .find(this.sizeSelector)
                .animate({opacity: 1}, 200);
        } else {
            this.$pdpMainSection
                .find(this.sizeSelector)
                .find('.size-selector__size--active')
                .removeClass('size-selector__size--active')
                .end()
                .animate({opacity: 1}, 200);
        }
    },
    sizeChartBindHandler() {
        this.$pdpMainSection.on('click', '#js-pdp__sizechart', () => {
            this.customerServiceModal.modal('show');
            this.customerServiceModal.one('shown.bs.modal', () => {
                $('#cs-sizechart').closest('.collapse').collapse('show');
            });
        });
    },
    csModalBindHandler() {
        this.customerServiceModal.on('hidden.bs.modal', () => {
            this.customerServiceModal.find('.collapse.show').collapse('hide');
        });
    },
    add2cartBindHandler() {
        this.$pdpMainSection.on('click', '.js-pdp__add2cart', (evt) => {
            evt.preventDefault();
            const dataset = evt.currentTarget.dataset;
            if (dataset.notifyMe === 'true') {
                notifyMeService.showNotifyMeModal(dataset.code);
                return;
            }
            if (this.giftCard.isGiftcard) {
                detailPanel.collectGiftCardData();
            }
            addToCartService.addToCart(dataset.url, dataset.code, this.clearErrorMessages, this.renderErrorMessages, this.giftCard)
                            .then((request) => {
                                // add here code for after the request
                            });
        });
    },
    adjustAdd2CartButtons() {
        // Sticky button on mobile should also adjusted. Important to call this function after '#js-pdp__mobile-cart-panel' exchange
        if (this.sizeInitialized || this.giftCard.isGiftcard) {
            this.$pdpMainSection
                .find('.js-pdp__choose-size')
                .next('button')
                .removeClass('d-none')
                .end()
                .remove();
        }
    },
    adjustCompleteTheLookButton() {
        // Show "Complete the Look" button if related component is maintained
        if ($('#js-complete-the-look__component').length) {
            $('#js-pdp__complete-look').removeClass('d-none');
            $('#add-cart__form').addClass('combi-button');
        }
    },
    renderErrorMessages(errors) {
        const $errorContainer = $('.js-pdp__add-cart-errors');
        $.each(errors, (index, element) => {
            $errorContainer.append(`<div class="pdp__add-cart-error">${element}</div>`);
        });
    },
    clearErrorMessages() {
        $('.js-pdp__add-cart-errors').empty();
    },
    notifyMeBindHandler() {
        this.$pdpMainSection.on('click', '.js-pdp__notifyme', (evt) => {
            evt.preventDefault();
            const dataset = evt.currentTarget.dataset;
            notifyMeService.showNotifyMeModal(dataset.code);
        });
    },
    shopLookBindHandler() {
        this.$pdpMainSection.on('click', '#js-pdp__complete-look', (evt) => {
            evt.preventDefault();
            $('html, body').animate({
                scrollTop: $('#js-complete-the-look__component').offset().top - 100
            }, 2500, 'easeInOutQuart');
        });
    },
    adjustPersonalizedPrice() {
        const variantCode = document.querySelector('#js-pdp__details-panel').dataset.product;

        personalizeService.getPersonalizedData().then((data) => {
            personalizedProductService.fetchPersonalizedProductDataRequest(variantCode).then((data) => {
                // handle a possible change in price
                if (data.discountedPrice && data.oldPrice) {
                    this.refreshPrice(data.discountedPrice, data.oldPrice);
                } else {
                    $('#js-pdp__price').removeClass('invisible');
                }
                // check if product is restricted
                if (data.availableForDeliveryCountry) {
                    this.showAddToCartPanel();
                } else {
                    this.hideAddToCartPanel();
                    this.showRestrictedPanel();
                }
            }, (jqXHR) => {
                logger.error(`${jqXHR.status} error in fetchPersonalizedProductDataRequest`);
            });
        }, (jqXHR) => {
            logger.error(`${jqXHR.status} error in getPersonalizedData`);
        });
    },
    refreshPrice(discountedPrice, oldPrice) {
        const pricePanel = $('#js-pdp__price');

        if (discountedPrice && oldPrice) {
            // TODO: NOT WORKING
            let template = `<s class="pdp__price--strike">${oldPrice.formattedValue}</s>
                            <span class="pdp__price--discounted">${discountedPrice.formattedValue}</span>`;
            // main price
            pricePanel.html(template);
            // price on CTA
            $('#js-pdp__cta-bar-price').html(template);
        }
        pricePanel.removeClass('invisible');
    },
    showAddToCartPanel() {
        $('#js-pdp__cart-panel').removeClass('invisible');
    },
    hideAddToCartPanel() {
        $('#js-pdp__cart-panel').addClass('d-none');
    },
    showRestrictedPanel() {
        $('#js-restricted-panel').removeClass('d-none');
    },
    loadEmployeePDP(baseID, productCode) {
        logger.debug('Loading ambassador product');
        spinner.visibility(true)
        employee.loadEmployeePDPRequest(baseID, productCode)
                .done((data) => {
                    $('#page-main__pdp--restricted').replaceWith(data);
                    this.startUp();
                    pdpSliderGallery.cacheSelectors();
                    pdpSliderGallery.bindHandler();
                    imagePanel.init();
                    imagePanel.bindHandler();
                    ctaBar.$ctaBar = $('.pdp__cta-bar');
                    if (ctaBar.$ctaBar.length) {
                        ctaBar.bindCtaObservable();
                        ctaBar.ctaButtonClick();
                    }
                    if ($('.js-product-carousel').length) {
                        relatedProducts.bindHandler();
                    }
                    completeTheLook.init();
                    completeTheLook.bindEvents();
                    mediaLazyLoad.refreshLazyLoad();
                    parallax.reloadParallaxPool();
                    startCloudinaryResponsive();
                })
                .fail(() => {
                    //restricted site not available for the user -> redirect
                    window.location.replace(urlService.getBaseUrl());
                })
                .always(() => {
                    spinner.visibility(false);
                });
    },

    giftCardBindings() {
        const $textArea              = this.detailsPanelArea.find('.gift-card__textarea');
        const $inputFieldCustomValue = this.detailsPanelArea.find('.gift-card__value-selector input[type=text]');

        //Reveal button if it's gift card
        this.adjustAdd2CartButtons();

        // Free form price field action and frontend validation
        $inputFieldCustomValue.on('click change blur', function (e) {
            const $textInput   = $(e.target);
            let formattedValue = parseFloat($textInput.val()
                                                      .replace(/[^\d\-.,]/g, '')
                                                      .replace(/,/g, '.')
                                                      .replace(/\.(?=.*\.)/g, '')).toFixed(2);
            isNaN(formattedValue) ? formattedValue = '' : undefined;
            $textInput.val(formattedValue)
                      .parent().parent()
                      .find('input[type=radio]')
                      .val(formattedValue)
                      .prop('checked', true)
                      .trigger('change');
        });

        // For counter indicator of message length
        $textArea.on('blur keyup input paste', (evt) => {
            const textAreaValue   = $textArea.val();
            const $counterWrapper = detailPanel.detailsPanelArea.find('.gift-card__message-counter');
            const maxChars        = $textArea.data('message-limit');
            $textArea.val(textAreaValue.replace(/(\r\n|\n|\r)/gm, evt.type === "paste" ? " " : ""));
            if (textAreaValue.length <= maxChars) {
                detailPanel.giftCard.message = textAreaValue;
                $textArea.siblings()
                         .find('.js-gift-card__message-length')
                         .text(textAreaValue.length)
            } else {
                $textArea.val(textAreaValue.substr(0, maxChars));
            }

            textAreaValue.length < maxChars ? $counterWrapper.removeClass('error') : $counterWrapper.addClass('error');
        });

        // In case of navigating fw or bw, trigger change onto fields to trigger logic
        $inputFieldCustomValue.trigger('change');
        $textArea.trigger('blur');

    },

    collectGiftCardData() {
        const $selectedGiftCardValue = this.detailsPanelArea.find('input[type=radio]:checked')
        detailPanel.giftCard.amount  = parseFloat($selectedGiftCardValue.val()).toFixed(2);
        detailPanel.giftCard.message = this.detailsPanelArea.find('.gift-card__textarea').val();
    },

    clearGiftCardMessage() {
        if (this.detailsPanelArea) {
            const $textarea = this.detailsPanelArea.find('.gift-card__textarea');
            if ($textarea.length) {
                $textarea.val('').trigger('blur')
            }
        }
    },

    descriptionShortener() {
        const $description = $('.pdp__short-description');
        $description.text($('.cms-productdetails__content').text());
    },

    buildColorVariantSlider() {
        if (detailPanel.$colorVariantSliderContainer.length && Breakpoints.is('desktop')) {
            const $colorVariantSliderNavigation = $('#js-color-selector-carousel__nav');
            this.colorVariantSlider             = tns({
                container:         this.colorVariantSliderSelector,
                mode:              'carousel',
                items:             9,
                slideBy:           7,
                loop:              false,
                controls:          true,
                controlsContainer: $colorVariantSliderNavigation[0],
                nav:               false,
                arrowKeys:         true,
                speed:             300,
                lazyload:          false,
                mouseDrag:         false,
                onInit:            () => {
                    $(this.colorVariantSliderSelector).removeClass('color-selector--not-initialized');
                    $colorVariantSliderNavigation.removeClass('d-none')
                },
            });
        }
    },

    destroyColorVariantSlider() {
        if (this.colorVariantSlider && typeof (this.colorVariantSlider.destroy) === typeof (Function)) {
            this.colorVariantSlider.destroy();
        }
    },

    bindColorVariantSlider() {
        if (detailPanel.$colorVariantSliderContainer.length) {
            Breakpoints.on('desktop', {
                enter: () => {
                    detailPanel.buildColorVariantSlider();
                },
                leave: () => {
                    detailPanel.destroyColorVariantSlider();
                }
            });
        }
    },

    calculateStickyType() {
        const target = document.querySelector('.pdp__additional-panel');
        if (target) {
            const targetHeight = target.offsetHeight;
            const viewHeight   = window.innerHeight;
            if (viewHeight - targetHeight > 100) {
                target.classList.add('pdp__additional-panel--sticky-top');
            }
        }
    },

    sizeChartSwitch() {
        const productPanel = $('#cms-productimagery-module__component');
        productPanel.on('change', 'input[type=radio][name=sizechart]', function () {
            if ($(this).val() === "size-centimeter") {
                productPanel.find('.sizechart-content-cm').removeClass('d-none');
                productPanel.find('.sizechart-content-inch').addClass('d-none');
            } else {
                productPanel.find('.sizechart-content-inch').removeClass('d-none');
                productPanel.find('.sizechart-content-cm').addClass('d-none');
            }
        });
    },

    startUp() {
        startCloudinaryResponsive();
        trackingPdp.readTrackingData(document.querySelector('#js-pdp__tracking-data'));
        detailPanel.cacheSelectors();
        detailPanel.colorVariantBindHandler();
        detailPanel.sizeVariantBindHandler();
        detailPanel.chooseSizeBindHandler();
        detailPanel.adjustSizeVariantState();
        detailPanel.sizeChartBindHandler();
        detailPanel.csModalBindHandler();
        detailPanel.add2cartBindHandler();
        detailPanel.notifyMeBindHandler();
        detailPanel.shopLookBindHandler();
        detailPanel.adjustPersonalizedPrice();
        detailPanel.adjustCompleteTheLookButton();
        detailPanel.descriptionShortener();
        detailPanel.sizeChartSwitch();
        detailPanel.calculateStickyType();
        if (this.giftCard.isGiftcard) {
            detailPanel.giftCardBindings();
        }
        detailPanel.bindColorVariantSlider();

        // Post actions
        detailPanel.preselectFirstAvailableSize('#js-size-selector__wrapper', '.js-size-selector__size');
    }
};

// DOM ready
$(() => {
    if (document.querySelector(detailPanel.pdpMainSection)) {
        if (alphatauri.config.employee && alphatauri.config.employee.restrictedUserGroups) {
            detailPanel.loadEmployeePDP(alphatauri.config.employee.baseID, alphatauri.config.employee.productCode);
        } else {
            detailPanel.startUp();
        }
    }
});

export default detailPanel;
